// src/data/country-documents.js
// Country-specific document templates for global compliance
// src/data/country-documents.js - UPDATED Nigeria Section

export const COUNTRY_DOCUMENTS = {
  Nigeria: {
    name: 'Nigeria',
    currency: 'NGN',
    currencySymbol: '₦',
    totalDocuments: 30, // ✅ Updated to 30
    categories: [
      { id: 1, name: 'Corporate & Structure', icon: 'Building2' },
      { id: 2, name: 'Core Financials & Tax', icon: 'Wallet' },
      { id: 3, name: 'Team & Human Capital', icon: 'Users' },
      { id: 4, name: 'Risk, Compliance & ESG', icon: 'ShieldCheck' },
      { id: 5, name: 'Legal & Protection', icon: 'Scale' },
      { id: 6, name: 'Sector-Specific (Optional)', icon: 'Briefcase' }, // ✅ NEW
    ],
    documents: [
      // ============================================================
      // Category 1: Corporate & Structure (5 docs)
      // ============================================================
      { id: 'cac-cert', label: 'CAC Incorporation Certificate', category: 1, critical: true },
      { id: 'memart', label: 'Memorandum & Articles of Association', category: 1, critical: true },
      { id: 'status-report', label: 'CAC Status Report / Form CAC 1.1', category: 1, critical: false },
      { id: 'share-cert', label: 'Share Certificates Issued', category: 1, critical: false },
      { id: 'commencement', label: 'Notice of Commencement of Business', category: 1, critical: false },

      // ============================================================
      // Category 2: Core Financials & Tax (6 docs)
      // ============================================================
      { id: 'tin-letter', label: 'TIN Designation Letter', category: 2, critical: true },
      { id: 'scuml-cert', label: 'SCUML Clearance Certificate', category: 2, critical: true, recurring: true },
      { id: 'vat-reg', label: 'VAT Registration Certificate', category: 2, critical: false },
      { id: 'audit-current', label: 'Audited Financial Statements (Current Year)', category: 2, critical: false, recurring: true },
      { id: 'tax-clearance', label: 'Tax Clearance Certificate (TCC) - Current', category: 2, critical: false, recurring: true },
      // ✅ NEW: Bank Statement
      { id: 'bank-statement', label: 'Bank Statement (6 months)', category: 2, critical: false, recurring: true },

      // ============================================================
      // Category 3: Team & Human Capital (6 docs)
      // ============================================================
      { id: 'founder-agmt', label: 'Founders Accord & Reverse Vesting', category: 3, critical: true },
      { id: 'ip-assign', label: 'IP Assignment & Proprietary Inventions', category: 3, critical: true },
      { id: 'emp-contract', label: 'Standard Employment Agreement Template', category: 3, critical: false },
      { id: 'pencom', label: 'PenCom Compliance Certificate', category: 3, critical: false, recurring: true },
      { id: 'itf-cert', label: 'ITF Compliance Certificate', category: 3, critical: false, recurring: true },
      // ✅ NEW: NSITF
      { id: 'nsitf', label: 'NSITF Compliance Certificate', category: 3, critical: false, recurring: true },

      // ============================================================
      // Category 4: Risk, Assets & Governance (5 docs)
      // ============================================================
      { id: 'board-res', label: 'Board Resolutions Log', category: 4, critical: false },
      { id: 'ndas', label: 'Mutual & Unilateral NDA Templates', category: 4, critical: false },
      { id: 'data-privacy', label: 'NDPR / Data Protection Privacy Policy', category: 4, critical: false },
      { id: 'insurance', label: 'Keyperson / Commercial Liability Policy', category: 4, critical: false },
      // ✅ NEW: Risk Assessment
      { id: 'risk-assessment', label: 'Risk Assessment & Management Policy', category: 4, critical: false },

      // ============================================================
      // Category 5: Legal & Protection (5 docs)
      // ============================================================
      { id: 'trademark', label: 'Brand Trademark Registration Filing', category: 5, critical: false },
      { id: 'service-agmt', label: 'Master Services Agreement (MSA)', category: 5, critical: false },
      { id: 'sla-template', label: 'SLA / Customer Terms of Service', category: 5, critical: false },
      { id: 'shareholders-agmt', label: 'Shareholders Agreement', category: 5, critical: true },
      // ✅ NEW: Data Processing Agreement
      { id: 'dpa', label: 'Data Processing Agreement (DPA)', category: 5, critical: false },

      // ============================================================
      // Category 6: Sector-Specific (Optional) - NEW
      // ============================================================
      // Trade/Export
      { id: 'export-license', label: 'Export License', category: 6, critical: false, sector: 'trade' },
      { id: 'import-license', label: 'Import License', category: 6, critical: false, sector: 'trade' },
      { id: 'bill-of-lading', label: 'Bill of Lading (Sample)', category: 6, critical: false, sector: 'trade' },
      // Product/Manufacturing
      { id: 'nafdac', label: 'NAFDAC Registration', category: 6, critical: false, sector: 'product' },
      { id: 'soncap', label: 'SONCAP Certification', category: 6, critical: false, sector: 'product' },
      // Government Contracting
      { id: 'bpp-reg', label: 'BPP Registration (Bureau of Public Procurement)', category: 6, critical: false, sector: 'government' },
      // International
      { id: 'duns', label: 'DUNS Number', category: 6, critical: false, sector: 'international' },
    ]
  },
 
  
  'United States': {
    name: 'United States',
    currency: 'USD',
    currencySymbol: '$',
    totalDocuments: 28,
    categories: [
      { id: 1, name: 'Corporate & Structure', icon: 'Building2' },
      { id: 2, name: 'Tax & Financial', icon: 'Wallet' },
      { id: 3, name: 'Employment & HR', icon: 'Users' },
      { id: 4, name: 'Compliance & Privacy', icon: 'ShieldCheck' },
      { id: 5, name: 'Legal & Protection', icon: 'Scale' },
    ],
    documents: [
      // Category 1: Corporate & Structure
      { id: 'articles-inc', label: 'Articles of Incorporation', category: 1, critical: true },
      { id: 'bylaws', label: 'Corporate Bylaws', category: 1, critical: true },
      { id: 'operating-agmt', label: 'Operating Agreement (LLC)', category: 1, critical: true },
      { id: 'cert-good-standing', label: 'Certificate of Good Standing', category: 1, critical: false },
      { id: 'stock-cert', label: 'Stock Certificates', category: 1, critical: false },
      { id: 'foreign-qualification', label: 'Foreign Qualification (if applicable)', category: 1, critical: false },
      // Category 2: Tax & Financial
      { id: 'ein', label: 'EIN Confirmation Letter', category: 2, critical: true },
      { id: 'finCEN', label: 'FinCEN Registration (AML)', category: 2, critical: true },
      { id: 'state-tax', label: 'State Tax Registration', category: 2, critical: false },
      { id: 'sales-tax', label: 'Sales Tax Permit', category: 2, critical: false },
      { id: 'audited-fin', label: 'Audited Financial Statements', category: 2, critical: false },
      // Category 3: Employment & HR
      { id: 'employment-agmt', label: 'Employment Agreements', category: 3, critical: true },
      { id: 'ip-assign', label: 'IP Assignment Agreement', category: 3, critical: true },
      { id: 'non-compete', label: 'Non-Compete & Non-Solicit', category: 3, critical: false },
      { id: 'employee-handbook', label: 'Employee Handbook', category: 3, critical: false },
      { id: 'immigration-docs', label: 'Immigration Documents (if applicable)', category: 3, critical: false },
      // Category 4: Compliance & Privacy
      { id: 'data-privacy', label: 'Privacy Policy (CCPA/CPRA)', category: 4, critical: true },
      { id: 'terms-service', label: 'Terms of Service', category: 4, critical: true },
      { id: 'cookies-policy', label: 'Cookies Policy', category: 4, critical: false },
      { id: 'insurance', label: 'Insurance Policies', category: 4, critical: false },
      // Category 5: Legal & Protection
      { id: 'shareholders-agmt', label: 'Shareholders Agreement', category: 5, critical: true },
      { id: 'msa', label: 'Master Services Agreement (MSA)', category: 5, critical: true },
      { id: 'nda', label: 'NDA Template', category: 5, critical: true },
      { id: 'founders-agmt', label: 'Founders Agreement', category: 5, critical: true },
    ]
  },
  
  'United Kingdom': {
    name: 'United Kingdom',
    currency: 'GBP',
    currencySymbol: '£',
    totalDocuments: 26,
    categories: [
      { id: 1, name: 'Corporate & Structure', icon: 'Building2' },
      { id: 2, name: 'Tax & Financial', icon: 'Wallet' },
      { id: 3, name: 'Employment & HR', icon: 'Users' },
      { id: 4, name: 'Compliance', icon: 'ShieldCheck' },
      { id: 5, name: 'Legal', icon: 'Scale' },
    ],
    documents: [
      // Category 1: Corporate & Structure
      { id: 'companies-house', label: 'Companies House Registration', category: 1, critical: true },
      { id: 'mem-arts', label: 'Memorandum & Articles of Association', category: 1, critical: true },
      { id: 'confirmation', label: 'Confirmation Statement', category: 1, critical: false },
      { id: 'cert-incorporation', label: 'Certificate of Incorporation', category: 1, critical: true },
      { id: 'persons-control', label: 'PSC Register', category: 1, critical: false },
      // Category 2: Tax & Financial
      { id: 'utr', label: 'UTR (Unique Taxpayer Reference)', category: 2, critical: true },
      { id: 'vat-reg', label: 'VAT Registration', category: 2, critical: true },
      { id: 'corp-tax', label: 'Corporation Tax Registration', category: 2, critical: false },
      { id: 'paye', label: 'PAYE Registration', category: 2, critical: false },
      // Category 3: Employment & HR
      { id: 'employment-contract', label: 'Employment Contracts', category: 3, critical: true },
      { id: 'ip-assign', label: 'IP Assignment', category: 3, critical: true },
      { id: 'employee-handbook', label: 'Staff Handbook', category: 3, critical: false },
      // Category 4: Compliance
      { id: 'aml-reg', label: 'AML Registration', category: 4, critical: true },
      { id: 'data-privacy', label: 'GDPR Privacy Policy', category: 4, critical: true },
      { id: 'cookies', label: 'Cookies Policy', category: 4, critical: false },
      // Category 5: Legal
      { id: 'shareholders-agmt', label: 'Shareholders Agreement', category: 5, critical: true },
      { id: 'msa', label: 'MSA Template', category: 5, critical: true },
      { id: 'nda', label: 'NDA Template', category: 5, critical: true },
    ]
  },
  
  // Add more countries as needed
  Kenya: {
    name: 'Kenya',
    currency: 'KES',
    currencySymbol: 'KSh',
    totalDocuments: 24,
    categories: [
      { id: 1, name: 'Corporate & Structure', icon: 'Building2' },
      { id: 2, name: 'Tax & Financial', icon: 'Wallet' },
      { id: 3, name: 'Employment & HR', icon: 'Users' },
      { id: 4, name: 'Compliance', icon: 'ShieldCheck' },
      { id: 5, name: 'Legal', icon: 'Scale' },
    ],
    documents: [
      { id: 'e-citizen', label: 'e-Citizen Registration', category: 1, critical: true },
      { id: 'cert-incorporation', label: 'Certificate of Incorporation', category: 1, critical: true },
      { id: 'mem-arts', label: 'Memorandum & Articles', category: 1, critical: true },
      { id: 'kra-pin', label: 'KRA PIN Certificate', category: 2, critical: true },
      { id: 'vat-reg', label: 'VAT Registration', category: 2, critical: false },
      { id: 'aml-reg', label: 'AML Registration', category: 4, critical: false },
      // ... add more
    ]
  },
  
  'South Africa': {
    name: 'South Africa',
    currency: 'ZAR',
    currencySymbol: 'R',
    totalDocuments: 24,
    categories: [
      { id: 1, name: 'Corporate & Structure', icon: 'Building2' },
      { id: 2, name: 'Tax & Financial', icon: 'Wallet' },
      { id: 3, name: 'Employment & HR', icon: 'Users' },
      { id: 4, name: 'Compliance', icon: 'ShieldCheck' },
      { id: 5, name: 'Legal', icon: 'Scale' },
    ],
    documents: [
      { id: 'cipc', label: 'CIPC Registration', category: 1, critical: true },
      { id: 'cert-incorporation', label: 'Certificate of Incorporation', category: 1, critical: true },
      { id: 'mem-arts', label: 'Memorandum & Articles', category: 1, critical: true },
      { id: 'sars', label: 'SARS Tax Registration', category: 2, critical: true },
      { id: 'vat-reg', label: 'VAT Registration', category: 2, critical: false },
      { id: 'fic-reg', label: 'FIC Registration', category: 4, critical: false },
      // ... add more
    ]
  },
}

// Helper functions
export function getCountryDocuments(country) {
  return COUNTRY_DOCUMENTS[country] || COUNTRY_DOCUMENTS.Nigeria
}

export function getSupportedCountries() {
  return Object.keys(COUNTRY_DOCUMENTS)
}

export function getCountryDocumentCount(country) {
  const data = getCountryDocuments(country)
  return data?.totalDocuments || 0
}

export function getCountryCategories(country) {
  const data = getCountryDocuments(country)
  return data?.categories || []
}

export function getCountryDocumentsList(country) {
  const data = getCountryDocuments(country)
  return data?.documents || []
}

export default COUNTRY_DOCUMENTS